import React, { Component } from 'react';
import { ListLayout } from '../containers/Layout';
import Pagination from '../../../../commonModules/interface/Pagination';

import Select from 'react-select'
import SingleResa from './SingleResa';
import Dialog from '../../../../commonModules/interface/Dialog';
import PopUp from '../../../../commonModules/interface/PopUp';
import InputText, { InputSelect } from '../../../../commonModules/interface/form-input-inline';
import { TableHead, TableBody, TableRow, TableCell, Button, IconButton, Box, Grid, Tooltip } from '@material-ui/core';
import DeleteDialogConfirm from '../../../../commonModules/interface/DeleteDialogConfirm';
import { AddRounded, CheckRounded, CloseRounded, DeleteRounded, AddBoxRounded, CheckBoxRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import { isEmpty, size } from 'lodash';
import ClientPopUp from '../clients/ClientPopUp';
import FormResaToSale from './FormResaToSale';
import { toast } from 'react-toastify';

class ListResa extends Component {
    state = { 

        deletePopUp: false,
        toDeleteClient:"",
        toDelete:{
            id:"",
        },
       
        view: "list",
        clientPopUp: false,
        client:{}

    }
    componentDidMount = () => {
        console.log("MOUNTING ListResas ");
    }
    
    createResaList = (list) => {
        const { SHOPS, CLIENTS, rowsPerPage, currentPage } = this.props

        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(resa => {
            if(resa){ // need to check after delete resa/prepa to prevent error
                const client = CLIENTS[resa.client_ref]
                let client_name = client ? `${client.client_firstname} ${client.client_lastname}` : ""
                const shop = SHOPS[resa.shop_id]
                // console.log({resa, shop, client});
                return (        
                    <TableRow key={resa.id}>
                        {/* <td>{resa.id}</td> */}
                        <TableCell>{(new Date(resa.date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                        {shop ? (
                            <a href="#" onClick={ () => this.props.handleSingleShop(shop) } >{shop.name}</a>
                        ) : (
                            <span>{resa.shop_id}</span>
                        )}
                        </TableCell>
                        <TableCell>
                            {client && 
                                <a href="#" onClick={ () => this.setState({ client, clientPopUp: true }) }>{client_name}</a> 
                            }
                        </TableCell>
                        <TableCell>
                            <IconButton color="secondary" onClick={ () => this.props.handleSingleResa(resa, shop, client) }>
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <Tooltip placement="top" title="Compléter">
                                <IconButton onClick={() => this.props.handleResaToSale(resa, client)} >
                                    <CheckBoxRounded color="primary" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                        <TableCell>
                            <Tooltip placement="top" title="Annuler">
                                <IconButton onClick={()=> this.setState({
                                        toDelete: resa,
                                        toDeleteClient: client_name,
                                        deletePopUp : true
                                    })
                                }>
                                    <CloseRounded color="error" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                )
            }
        })        
    }  
    
    displayList = () => {
        const { RESAS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(RESAS)){
            let filteredList = this.props.getFilteredList()
            rows = size(filteredList)
            tab = this.createResaList(filteredList)
        }
        return [tab, rows]
    }  
        
    deleteResa = async (comments) => {
        let data = {
            op_id: this.state.toDelete.id,
            comments
        }
        this.props.deleteResa(data)
        if(this.props.STATE.resas.error){
            console.log("[ERROR] delete resa", this.props.STATE.resas.error); 
            toast.error(  "Un Problème est survenu")
        } else {
            toast.success( "Réservation supprimée avec succès")
            this.setState({
                deletePopUp:false,
                toDelete:{id: ""},
            })
        }  
    }

    render() {
        const { view } = this.state;
        let resaList = this.displayList()

        console.log('====================================');
        console.log("[STATE] LIST RESA", this.state);
        console.log('====================================');

        return (
            <React.Fragment>
                {this.state.deletePopUp &&
                    <DeleteDialogConfirm
                        open={true}
                        close={()=>this.setState({deletePopUp: false})}
                        title={"la reservation pour "+ this.state.toDeleteClient}
                        handleSubmit={this.deleteResa}
                        disabledSubmit={this.props.STATE.resas.fetching}
                    />
                }
                {this.state.clientPopUp && !isEmpty(this.state.client) &&
                    <ClientPopUp 
                        client={this.state.client}
                        {...this.props}
                        closePopUp={() => this.setState({clientPopUp:false, client:{}}) }
                    />
                }
                
                { view === "list" &&
                    <Box>
                        <ListLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Shop</TableCell>
                                    <TableCell>Nom Client</TableCell>
                                    <TableCell>Détails</TableCell>
                                    <TableCell>Compléter</TableCell>
                                    <TableCell>Annuler</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { resaList[1] !== 0  && 
                                    resaList[0]
                                }
                                { resaList[1] === 0  && 
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <div className="text-center">
                                            <h5>Pas encore de Réservation</h5> 
                                            Cliquez sur <b className="onglet">"Nouveau"</b> Pour créer une nouvelle Réservation
                                        </div>
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                            { resaList[1] > 20  && 
                                <TableFooterPagination 
                                    colSpan={7}
                                    count={resaList[1]}
                                    onChangePage={this.props.onChangePage}
                                    initialPage={this.props.currentPage || 0}
                                    page={this.props.currentPage}
                                />         
                            }           
                        </ListLayout>
                    </Box>
                }
            </React.Fragment>
        );
    }
}


export default ListResa;